import { getDeviceType } from '@cognitoforms/utils/user-agent';

export default function shouldHideDateTimeIcon(mobile: boolean, textValue: string, inputElement: HTMLInputElement) {
	if (
		!mobile ||
		!textValue.length ||
		!(getDeviceType(window.navigator.userAgent) === 'ipad' || getDeviceType(window.navigator.userAgent) === 'iphone')
	)
		return false;

	const dateInputThreshold: number = 110;
	const timeInputThreshold: number = 85;
	const type: 'date' | 'time' = inputElement.getAttribute('type') as any;

	// Thresholds will work for most locales but not all. Vietnamese dates, for example, will still have a problem.
	return inputElement.clientWidth < (type === 'date' ? dateInputThreshold : timeInputThreshold);
}